import {Box, CardMedia, IconButton, Tooltip} from '@mui/material';
import activityIndicatorCircle from '../../assets/circle_activity_indicator.svg';
import inactivityIndicatorCircle from '../../assets/circle_inactivity_Indicator.svg';
import React, {useRef, useState} from 'react';
import CardViewAdFooter from './CardViewAdFooter';
import {BookmarkBorderOutlined, FileDownloadOutlined, Pause, PlayArrow, AutoAwesome} from '@mui/icons-material'; // Añadido 'Pause' y AutoAwesome
import {DownloadImgFromUrl} from '../../services/DownloadSvc';
import './cardViews.css';
import logoBeta from './../../assets/logobeta.png'
import smartToyIcon from './smart_toy_24dp_E3E3E3.svg';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { normalizeCreativeUrl } from '../../utils/Utils';


// Create the PostCard component that accepts `item` as a prop
export default function CardViewAd({index, item, launchCategoryDialog, gridShowAdDetail, launchAdIADetailsDialog, saveProgress, featureUsage, isFeatureUsageLoading}) {
    /*  INIT VARS - HOOKS   */

    /**
     * Configura la propiedad 'display' ('none','block') del toolbar. De esta manera se oculta o se muestran
     * los botones de accion del cardView
     */
    const [displayToolbar, setDisplayToolbar] = useState('none');
    const videoRef = useRef(null);  // (ECA) Referencia para acceder al elemento video
    const [isPlaying, setIsPlaying] = useState(false);  // (ECA) Seguimiento al estado de reproducción del vídeo
    /**
    * Estilo para los botones de accion.
    * @type {{backgroundColor: string, color: string, '&:hover': {background: string}}}
    */
    const styleBtnIcon = {
        backgroundColor: 'white', color: 'black', '&:hover': {background: '#c5bebe'}, ml: 1
    };
    /*  END VARS - HOOKS   */


    /*  INIT EVENTS */

    /**
     * Mostras los botones de accion en el card
     */
    const showActionButtons = () => {
        setDisplayToolbar('block')
    }
    /**
     * Ocultar los botones de accion en el card
     */
    const hideActionButtons = () => {
        setDisplayToolbar('none')
    }
    /**
     * Descargar el creativo
     * @param fileType
     * @param src
     * @return {Promise<void>}
     */
    const onclickDownloadCreative = async (fileType, src) => {
        await DownloadImgFromUrl(src, fileType)
    }

    /**
     * (ECA) Función para controlar la reproducción de videos
     */
    const togglePlayVideo = (accion) => {
        if (accion === 'video') {
            if (videoRef.current) {
                if (isPlaying) {
                    videoRef.current.pause();  // Pausa el video si está reproduciendo
                } else {
                    videoRef.current.play();  // Reproduce el video si está pausado
                }
                setIsPlaying(!isPlaying);  // Alternar el estado de reproducción
            }
        }

    }

    /**
     * (ECA) Manejo del clic en la grilla para mostrar los detalles
     */
    const onClickCardView = (e) => {
        if (e.target.className === 'card-view-ad-layout-shadow') {
            if (gridShowAdDetail) {
                gridShowAdDetail(item);
            }
        }
        if (e.target.className === 'toggle-button') {
            return false;
        }
    }

    const copyLibraryId = () => {

    }

    /*  END EVENTS  */

    const shouldShowSaveProgress = typeof saveProgress === 'number' && !Number.isNaN(saveProgress);
    const clampedSaveProgress = shouldShowSaveProgress
        ? Math.max(0, Math.min(100, Math.round(saveProgress)))
        : 0;

    const anaUsage = Array.isArray(featureUsage)
        ? featureUsage.find((entry) => typeof entry?.FK_FeaturePlanCode === 'string' && entry.FK_FeaturePlanCode.includes('-Ana'))
        : null;
    const canShowIaButton = !isFeatureUsageLoading && anaUsage && Number(anaUsage.TotalUsed) > 0;

    const adCreativeSrc = normalizeCreativeUrl(item?.AdCreative);

    return (
        <div
            className={'card-view-ad-layout-main'}
            onMouseOver={showActionButtons}
            onMouseOut={hideActionButtons}> {/* Set position to relative */}
            {shouldShowSaveProgress && (
                <div
                    className="card-save-progress"
                    role="progressbar"
                    aria-label="Guardando anuncio"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={clampedSaveProgress}
                >
                    <div className="card-save-progress__bar" style={{ width: `${clampedSaveProgress}%` }} />
                </div>
            )}
            {item?.AdMedia === 'video' ? ( // Conditional rendering: Check if the media type is a video
                <video
                    ref={videoRef}
                    // poster={logoBeta}
                    poster={!item?.url_preview_creative?.includes('fbcdn') ? item.url_preview_creative : undefined}
                    src={adCreativeSrc}/>
            ) : (
                <img src={adCreativeSrc} alt='imagen'/>

            )}
            <div className={'card-view-ad-layout-shadow'} onClick={onClickCardView} style={{display: displayToolbar}}>
                <div className={'card-view-ad-layout-shadow-container-buttons'}>
                    
                    <IconButton sx={styleBtnIcon}>
                        <FileDownloadOutlined className="download-icon"
                            onClick={(e) => {
                                onclickDownloadCreative(item?.AdMedia, adCreativeSrc)
                            }}/>
                    </IconButton>

                    <IconButton sx={styleBtnIcon}
                                onClick={(e) => launchCategoryDialog(item)}>
                        <BookmarkBorderOutlined className="bookmark-icon"/>
                    </IconButton>
                    {/* Icono de IA */}
                    
                    {canShowIaButton && (
                        <IconButton
                            sx={styleBtnIcon}
                            onClick={(e) => (launchAdIADetailsDialog ? launchAdIADetailsDialog(item) : launchCategoryDialog(item))}
                        >
                            <AutoAwesome className="ia-icon" htmlColor="#000000" /> 
                        </IconButton>
                    )}

                    {
                        item?.AdMedia === 'video' && (
                            <IconButton onClick={(e) => togglePlayVideo('video')}
                                        sx={{
                                            backgroundColor: 'white',
                                            float: 'right',
                                            mr: 1,
                                            '&:hover': { background: '#c5bebe' }
                                        }}>
                                {isPlaying
                                    ? <Pause className="pause-icon" fontSize="large"/>
                                    : <PlayArrow className="play-icon" fontSize="large"/>} 
                                {/* Mostrar el icono de reproducción/pausa */}
                            </IconButton>
                        )
                    }

                    <IconButton
                        sx={styleBtnIcon}
                        onClick={(e) => {
                            if (gridShowAdDetail) {
                                gridShowAdDetail(item);
                            }
                        }}
                    >
                        <img
                            src={smartToyIcon}
                            alt="smart toy"
                            style={{ width: '24px', height: '24px', filter: 'brightness(0)' }}
                        />
                    </IconButton>
                </div>
            </div>


            {/* Footer Section */}
            <CardViewAdFooter index={index} item={item} activityIndicatorCircle={activityIndicatorCircle}
                              inactivityIndicatorCircle={inactivityIndicatorCircle}/>
        </div>
    )// end return
} // end main function
